<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-2/3 flex-1">
      <section v-if="applications_with_checklists.length">
        <h3 class="text-base md:text-xl text-gray-700 font-medium">Pending Document Dues</h3>
        <div
          class="mt-5 py-6 px-4 md:px-8 bg-white rounded shadow overflow-hidden"
          v-for="application in getApplications()"
          :key="application.id"
        >
          <div class="md:flex ">
            <div class="w-1/2 flex items-center">
              <donut :size="(windowWidth < 500) ? 50 : 61" :usage="getApplicationProgress(application)" />
              <div class="ml-4 md:ml-6">
                <h3 class="text-gray-900 text-lg md:text-xl font-medium truncate max-w-xs">
                  {{ application.product.name }}
                </h3>
                <p class="text-base md:text-lg text-gray-600 truncate max-w-xs ">
                  {{ application.partner.name }}
                </p>
              </div>
            </div>
            <div class="flex w-full md:w-1/2 justify-between md:justify-around mt-6 md:mt-0">
              <div class="flex">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 12.75V16.5H1.5V2.25H15.8535C15.9192 2.24989 15.9838 2.26706 16.0408 2.29979C16.0979 2.33252 16.1453 2.37966 16.1783 2.43648C16.2113 2.4933 16.2289 2.55781 16.2291 2.62355C16.2294 2.68928 16.2124 2.75392 16.1798 2.811L13.5 7.5L16.1798 12.189C16.2124 12.2461 16.2294 12.3107 16.2291 12.3765C16.2289 12.4422 16.2113 12.5067 16.1783 12.5635C16.1453 12.6203 16.0979 12.6675 16.0408 12.7002C15.9838 12.7329 15.9192 12.7501 15.8535 12.75H3ZM3 3.75V11.25H13.9155L11.772 7.5L13.9155 3.75H3Z"
                    fill="#ED8936"
                  />
                </svg>
                <div class="ml-2 max-w-xs">
                  <span class="text-gray-600 text-sm">
                    Current Stage
                  </span>
                  <p class="md:font-bold text-gray-900 truncate max-w-xxs">
                    {{ application.current_stage.name }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z"
                    fill="#38B2AC"
                  />
                  <path
                    d="M7.68742 10.9856L13.3745 5.25L14.25 6.13221L7.68742 12.75L3.75 8.77945L4.62485 7.89724L7.68742 10.9856Z"
                    fill="white"
                  />
                </svg>
                <div class="ml-3">
                  <p class="text-gray-600 text-sm">Requirement</p>
                  <p>{{ application.document_checklists.length || '-' }}</p>
                </div>
              </div>
            </div>
          </div>
          <p class="mt-6 text-gray-700 text-sm">Next Requirement Due</p>
          <div class="mt-1">
            <div
              class="mt-4 bg-gray-100 border rounded overflow-hidden"
              v-for="document in application.document_checklists"
              :key="document.id"
            >
              <div class="p-4 pb-3 flex justify-between">
                <div class="flex md:items-center w-8/12 max-w-xl ">
                  <span
                    class="w-5 h-5 bg-white border border-blue-300 rounded-full flex-shrink-0"
                  ></span>
                  <div class="w-full flex flex-col md:flex-row md:items-center">

                    <p class="ml-3 mb-2 md:mb-0 md:font-medium break-all">
                      {{ document.document_type_name }}
                    </p>
                    <p
                      style="place-self:flex-start"
                      class="mx-2 px-2 py-1 bg-red-500 uppercase font-bold text-white rounded text-xs md:text-sm flex-shrink-0"
                      v-if="document.due_date && document.due_date.is_due_soon"
                    >
                      DUE SOON
                    </p>
                  </div>
                </div>
                <div class="flex items-end md:items-start justify-end flex-col-reverse md:flex-row">
                  <p class="text-gray-600 text-sm md:text-base mt-2 md:mt-0 whitespace-nowrap">
                    Due:
                    {{ document.due_date && document.due_date.date || 'N/A' }}
                  </p>
                  <button
                    class="flex ml-6 items-center focus:outline-none"
                    @click="openDocumentUploadModal(document)"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 10.4877L13.5358 14.0227L12.3567 15.2018L10.8333 13.6785V18.3327H9.16667V13.6768L7.64334 15.2018L6.46417 14.0227L10 10.4877ZM10 1.66602C11.4308 1.66608 12.8117 2.19194 13.8802 3.14361C14.9486 4.09528 15.6301 5.4064 15.795 6.82768C16.8319 7.11045 17.7364 7.7486 18.3506 8.63062C18.9647 9.51264 19.2493 10.5824 19.1547 11.653C19.0601 12.7236 18.5923 13.7269 17.833 14.4875C17.0737 15.2482 16.0712 15.7178 15.0008 15.8144V14.136C15.3843 14.0813 15.753 13.9506 16.0855 13.7518C16.4179 13.553 16.7075 13.29 16.9371 12.978C17.1668 12.6661 17.3321 12.3115 17.4232 11.9351C17.5144 11.5586 17.5296 11.1677 17.4681 10.7852C17.4066 10.4028 17.2694 10.0364 17.0648 9.70756C16.8601 9.37868 16.592 9.09386 16.276 8.86974C15.9601 8.64562 15.6026 8.48667 15.2246 8.40219C14.8466 8.31771 14.4555 8.30938 14.0742 8.37768C14.2047 7.77009 14.1976 7.14099 14.0535 6.53648C13.9094 5.93196 13.6319 5.36734 13.2413 4.88396C12.8508 4.40058 12.357 4.01069 11.7962 3.74284C11.2355 3.475 10.6219 3.33599 10.0004 3.33599C9.37897 3.33599 8.76538 3.475 8.20461 3.74284C7.64384 4.01069 7.15008 4.40058 6.75951 4.88396C6.36893 5.36734 6.09143 5.93196 5.94732 6.53648C5.80322 7.14099 5.79616 7.77009 5.92667 8.37768C5.16638 8.23491 4.38052 8.4 3.74196 8.83665C3.10339 9.2733 2.66444 9.94573 2.52167 10.706C2.3789 11.4663 2.54399 12.2522 2.98064 12.8907C3.41729 13.5293 4.08972 13.9682 4.85 14.111L5 14.136V15.8144C3.92954 15.718 2.92701 15.2484 2.16761 14.4878C1.40822 13.7273 0.940276 12.724 0.845565 11.6534C0.750854 10.5828 1.0354 9.51292 1.64948 8.63083C2.26355 7.74874 3.16809 7.1105 4.205 6.82768C4.36976 5.40633 5.05117 4.09511 6.11965 3.1434C7.18813 2.1917 8.56913 1.6659 10 1.66602Z"
                        fill="#3182CE"
                      />
                    </svg>
                    <p class="ml-2 text-sm md:text-base text-blue-600">Upload</p>
                  </button>
                </div>
              </div>
              <div class="bg-gray-200 px-4 py-2" v-if="document.description">
                <p class="text-xs text-gray-800 overflow-ellipsis">
                  {{ document.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <button
          class="mt-2 text-blue-600"
          v-if="!seeMore && getAdditionalApplications() >= 1"
          @click="handleSeeMore"
        >
          See ({{ getAdditionalApplications() }}) More
        </button>
      </section>
      <section class="mt-8" v-if="applications.length">
        <h3 class="text-base md:text-xl text-gray-700 font-medium">
          In Progress Applications ({{ applications.length }})
        </h3>
        <div class="mt-5 flex relative items-center justify-center">
          <button
            class="-ml-3 absolute left-0 w-10 h-10 z-10 bg-white flex items-center justify-center focus:outline-none rounded-full flex-shrink-0 shadow-md"
            @click="prev"
            v-if="applications.length > 2"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 13L5 8L10 3"
                stroke="#A0AEC0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <VueSlickCarousel v-bind="settings">
            <div
              v-for="application in applications"
              :key="application.id"
              class="flex"
            >
              <div
                class="flex-1 my-1 mx-3 shadow bg-white rounded overflow-hidden"
              >
                <div class="px-4 md:px-8 py-3 md:py-6 flex items-center">
                  <donut :size="(windowWidth < 500) ? 50 : 61" :usage="getApplicationProgress(application)" />
                  <div class="ml-4 md:ml-6 flex flex-col pr-2 max-w-xs overflow-hidden">
                    <h3
                      class="text-black text-base md:text-lg font-medium overflow-ellipsis"
                    >
                      {{ application.product_name }}
                    </h3>
                    <p class="text-sm md:text-base text-gray-600 overflow-ellipsis">
                      {{ application.partner_name }}
                    </p>
                  </div>
                </div>
                <div
                  class="px-8 py-6 flex flex-col sm:flex-row justify-between border-t border-gray-200"
                >
                  <div class="flex md:max-w-1/2 mb-2 sm:mb-0">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 12.75V16.5H1.5V2.25H15.8535C15.9192 2.24989 15.9838 2.26706 16.0408 2.29979C16.0979 2.33252 16.1453 2.37966 16.1783 2.43648C16.2113 2.4933 16.2289 2.55781 16.2291 2.62355C16.2294 2.68928 16.2124 2.75392 16.1798 2.811L13.5 7.5L16.1798 12.189C16.2124 12.2461 16.2294 12.3107 16.2291 12.3765C16.2289 12.4422 16.2113 12.5067 16.1783 12.5635C16.1453 12.6203 16.0979 12.6675 16.0408 12.7002C15.9838 12.7329 15.9192 12.7501 15.8535 12.75H3ZM3 3.75V11.25H13.9155L11.772 7.5L13.9155 3.75H3Z"
                        fill="#ED8936"
                      />
                    </svg>
                    <div class="ml-2 flex flex-col max-w-full">
                      <span class="text-gray-600 text-sm">
                        Current Stage
                      </span>
                      <span class="truncate">
                        {{ application.current_stage_name }}
                      </span>
                    </div>
                  </div>
                  <div class="md:max-w-1/2 flex flex-shrink-0">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.83725 2.1195L9 0.75L15.1627 2.1195C15.3293 2.15652 15.4782 2.24922 15.585 2.3823C15.6918 2.51538 15.75 2.68089 15.75 2.8515V10.3417C15.7499 11.0826 15.567 11.8119 15.2174 12.465C14.8678 13.1181 14.3624 13.6749 13.746 14.0858L9 17.25L4.254 14.0858C3.63771 13.6749 3.13235 13.1183 2.78276 12.4653C2.43318 11.8124 2.25018 11.0832 2.25 10.3425V2.8515C2.25003 2.68089 2.30823 2.51538 2.41499 2.3823C2.52176 2.24922 2.6707 2.15652 2.83725 2.1195ZM3.75 3.453V10.3417C3.75001 10.8356 3.87193 11.3218 4.10495 11.7572C4.33796 12.1926 4.67486 12.5638 5.08575 12.8378L9 15.4478L12.9142 12.8378C13.325 12.5639 13.6619 12.1928 13.8949 11.7575C14.1279 11.3223 14.2499 10.8362 14.25 10.3425V3.453L9 2.2875L3.75 3.453ZM9 8.25C8.50272 8.25 8.02581 8.05246 7.67417 7.70083C7.32254 7.34919 7.125 6.87228 7.125 6.375C7.125 5.87772 7.32254 5.40081 7.67417 5.04917C8.02581 4.69754 8.50272 4.5 9 4.5C9.49728 4.5 9.97419 4.69754 10.3258 5.04917C10.6775 5.40081 10.875 5.87772 10.875 6.375C10.875 6.87228 10.6775 7.34919 10.3258 7.70083C9.97419 8.05246 9.49728 8.25 9 8.25ZM5.64525 12C5.73617 11.1738 6.12876 10.4102 6.74781 9.85554C7.36686 9.30088 8.16881 8.99416 9 8.99416C9.83119 8.99416 10.6331 9.30088 11.2522 9.85554C11.8712 10.4102 12.2638 11.1738 12.3547 12H5.64525Z"
                        fill="#A0AEC0"
                      />
                    </svg>
                    <div class="ml-3 flex flex-col">
                      <span class="text-gray-600 text-sm">Assignee</span>
                      <div class="max-w-xxs truncate">
                        <span class="truncate">
                          {{ getAssignee(application) }}
                        </span>
                        <span
                          class="text-sm text-gray-600"
                          v-if="additionalAssignees(application)"
                        >
                          + {{ additionalAssignees(application) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
          <button
            class="absolute right-0 -mr-3 w-10 h-10 z-10 bg-white flex items-center justify-center focus:outline-none rounded-full flex-shrink-0 shadow-md"
            @click="next"
            v-if="applications.length > 2"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 3L11 8L6 13"
                stroke="#A0AEC0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </section>
      <router-link
        to="/applications"
        class="my-5 bg-gray-200 py-3 flex items-center justify-center text-center text-blue-600 rounded sagar"
      >
        <span>
          See all applications
        </span>
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.72588 3L11.7259 8L6.72588 13"
            stroke="#3182CE"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </router-link>
    </div>
    <div class="w-full lg:w-1/3 md:px-5 sidebar">
      <sidebar />
    </div>
    <upload-documents-modal
      v-if="showDocumentUploadModal"
      @uploadDocumentsComplete="handleUploadComplete"
      @close="closeDocumentUploadModal"
      :documentId="documentToUpload.id"
      :documentName="documentToUpload.document_type_name"
      :dueSoon="isDueSoon(documentToUpload.due_date)"
    />
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import UploadDocumentsModal from '../../components/UploadDocumentModal.vue';
import Sidebar from './Sidebar.vue';
import moment from 'moment';
import axios from 'axios';
import { STATUS_COMPLETED } from '../Applications/const';

const APPLICATION_STATUS = {
  COMPLETE: 'Complete',
  OPEN: 'Open'
};

export default {
  name: 'Dashboard',
  components: {
    Donut: () => import('../../components/Donut.vue'),
    VueSlickCarousel,
    UploadDocumentsModal,
    Sidebar
  },
  async beforeRouteEnter(to, from, next) {
    let response = await axios.get('/api/applications/document-checklists');
    let applications_response = await axios.get('/api/applications', {
      params: {
        status: APPLICATION_STATUS.OPEN
      }
    });
    const { data } = response;
    next(vm => {
      vm.applications_with_checklists = data.data;
      vm.applications = applications_response.data;
    });
  },

  data() {
    return {
      applications_with_checklists: [],
      applications: [],
      showDocumentUploadModal: false,
      documentToUpload: null,
      settings: {
        adaptiveHeight: false,
        infinite: true,
        slidesToShow: 2,
        arrows: false,
        ref: 'carousel',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              focusOnSelect: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 375,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      },
      seeMore: false,
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },

    async fetchDocumentChecklist() {
      let { data } = await axios.get('/api/applications/document-checklists');
      this.applications_with_checklists = data.data;
    },
    getApplicationProgress(application) {
      if (application.status.label === 'Completed') {
        return 100;
      }

      const currentStageIndex = application.stages.findIndex(
        stage => stage.stage_id === application.current_stage.id
      );
      return Math.round((currentStageIndex / application.stages.length) * 100);
    },
    next() {
      const carouselRef = this.$refs.carousel;
      if (carouselRef) {
        carouselRef.next();
      }
    },
    prev() {
      const carouselRef = this.$refs.carousel;
      if (carouselRef) {
        carouselRef.prev();
      }
    },
    isApplicationCompleted(application) {
      return application.status.label === STATUS_COMPLETED;
    },
    getApplications() {
      if (!this.seeMore) {
        return this.applications_with_checklists.filter(
          (application, index) => index === 0
        );
      }
      return this.applications_with_checklists;
    },
    getAdditionalApplications() {
      return this.applications_with_checklists.length - 1;
    },
    handleSeeMore() {
      this.seeMore = true;
    },
    handleUploadComplete() {
      this.$toasted.success('Your document has been uploaded sucessfully');
      this.showDocumentUploadModal = false;
      this.fetchDocumentChecklist();
    },
    openDocumentUploadModal(document) {
      this.documentToUpload = document;
      this.showDocumentUploadModal = true;
    },
    closeDocumentUploadModal() {
      this.documentCheckListId = null;
      this.showDocumentUploadModal = false;
    },
    isDueSoon(due_date) {
      if (!due_date) {
        return false;
      }

      const due_date_moment = moment(due_date.date);
      const today = moment();
      const diff = due_date_moment.diff(today, 'days');
      if (diff < 7 && diff >= 0) {
        return true;
      }
      return false;
    },
    getAssignee(application) {
      const assignees = application.assignees;
      return assignees[0] ? assignees[0].name : 'N/A';
    },
    additionalAssignees(application) {
      if (application.assignees.length > 1) {
        return application.assignees.length - 1; // 1st one is already shown
      }
      return 0;
    }
  }
};
</script>
<style>
.slick-slider {
  max-width: 100% !important;
  width: 100%;
}
.overflow-ellipsis {
  overflow: ellipsis;
}
.slick-list{
  padding: 0 !important;
}
</style>
